module.exports = __webpack_public_path__ + "static/media/fondo_agrupacion.d5d8fca3.jpg";